"use client";

import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { useAuth } from "@/hooks/auth/useAuth";
import { cn } from "@/lib/utils";
import DynamicForm, {
  ButtonAction,
  FieldConfig,
} from "@/Shared/Form/DynamicForm";
import {
  setEmail,
  setPassword,
} from "@/store/Features/states/auth-management/authSlice";
import { useAppSelector } from "@/store/hooks";
import React from "react";

export function LoginForm({
  className,
  ...props
}: React.ComponentProps<"div">) {
  const { email, password, handleLogin, dispatch } = useAuth();
  const { isLoading } = useAppSelector((state) => state.auth);

  const fields: FieldConfig[] = [
    {
      type: "text",
      name: "email",
      label: "Email",
      placeholder: "Enter your email",
      required: true,
    },
    {
      type: "password",
      name: "password",
      label: "Password",
      placeholder: "Enter your password",
      required: true,
    },
  ];

  const actions: ButtonAction[] = [
    {
      title: "Login",
      type: "submit",
      variant: "default",
      className: "w-full",
      loading: isLoading,
    },
  ];

  const handleSubmit = (data: any) => {
    // Values are already in Redux state from onChange
    handleLogin();
  };

  const handleChange = (field: string, value: any) => {
    if (field === "email") {
      dispatch(setEmail(value));
    } else if (field === "password") {
      dispatch(setPassword(value));
    }
  };

  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Card className="w-full max-w-md mx-auto shadow-lg">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">Welcome Back</CardTitle>
          <CardDescription>
            Enter your credentials to access your account
          </CardDescription>
        </CardHeader>
        <CardContent>
          <DynamicForm
            fields={fields}
            onSubmit={handleSubmit}
            actions={actions}
            columns={1}
            values={{ email: email, password }}
            onChange={handleChange}
          />
          <div className="mt-4 text-center text-sm">
            <a
              href="#"
              className="underline underline-offset-4 hover:text-primary"
            >
              Forgot your password?
            </a>
          </div>
          <div className="mt-2 text-center text-sm text-muted-foreground">
            Don&apos;t have an account?{" "}
            <a
              href="#"
              className="underline underline-offset-4 hover:text-primary"
            >
              Sign up
            </a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
